<template>
<div class="app">
	<navbar
		v-if="showNavbar" 
	></navbar>
	<dashboardNavbar
		v-if="showDashboardNavbar"
	></dashboardNavbar>

	<router-view></router-view>

	<foot 
		v-if="showFooter"
	></foot>

	<toTopButton></toTopButton>
</div>

<div class="modal" id="attentionCaller" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="confirmationModalLabel">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="confirmationModalLabel">Você ainda está aí?</h1>
			</div>
		<div class="modal-body">
			Você está inativo há algum tempo. Se você não fizer nada, será desconectado automaticamente em <strong :style="{ color: remainingTime < 60 * 1000 ? 'red' : 'inherit' }">{{ minutesLeft }}:{{ secondsLeft }}</strong>.
		</div>
			<div class="modal-footer light-text">
				<button type="button" class="btn btn-primary w-auto px-2" data-bs-dismiss="modal" @click="resetTimeouts">Continuar</button>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import DashboardNavbar from './components/DashboardNavbar.vue';
import Foot from './components/Foot.vue';
import toTopButton from './components/ToTopButton.vue';
import Modal from 'bootstrap/js/dist/modal';

export default {
	components: {
		Navbar,
		Foot,
		toTopButton,
		DashboardNavbar
	},
	data() {
		return {
			navbarPages: ['/', '/contato', '/sobre'],
			footerPages: ['/', '/contato', '/sobre'],
			dashboardNavbarPages: ['/painel', '/cadastrar-loja', '/editar-loja',
								'/operacoes', '/controladoria-mensal', '/faq',
								'/cadastrar-rede', '/editar-rede', "/tabela-operacao",
								'/conta', '/cadastrar-operador', '/editar-operador',
								'/parametros', '/controladoria-anual'
			],

			logoutTimout: null,
			popupTimeout: null,
			timeoutDeltaTime: 1000 * 60 * 30,
			timeoutStartTime: null,

			remainingTime: 1000 * 60 * 1, // Default 1 minute (in milliseconds)

			isLoggedIn: JSON.parse(localStorage.getItem('isLoggedIn')) || false,
		}
	},
	created() {
		// Listen for the custom event
		window.addEventListener('isLoggedInChanged', this.handleCustomEvent);
	},
	unmounted() {
		// Clean up the event listener
		window.removeEventListener('isLoggedInChanged', this.handleCustomEvent);

		sessionStorage.clear(); // Clear session storage when the component is destroyed
	},
	computed: {
        currentPath() {
            return this.$route.path;
        },
		showNavbar() {
			// Retorna true se a página atual for uma das páginas que devem exibir a navbar
			return this.navbarPages.includes(this.currentPath);
		},
		showFooter() {
			// Retorna true se a página atual for uma das páginas que devem exibir a footer
			return this.footerPages.includes(this.currentPath);
		},
		showDashboardNavbar() {
			// Retorna true se a página atual for uma das páginas que devem exibir a navbar do dashboard
			return this.dashboardNavbarPages.includes(this.currentPath);
		},
		minutesLeft() {
			return Math.max(0, Math.floor(this.remainingTime / 1000 / 60)).toString().padStart(2, '0'); // Convert to minutes and zero fill to 2 characters
		},
		secondsLeft() {
			return Math.max(0, Math.floor((this.remainingTime / 1000) % 60)).toString().padStart(2, '0'); // Convert to seconds and zero fill to 2 characters
		},
    },
	methods: {
		startTimeouts() {
			this.timeoutStartTime = Date.now();
			this.remainingTime = this.timeoutDeltaTime;

			this.popupTimeout = setTimeout(() => {
				this.callAttention();
			}, 1000 * 60 * 27);

			this.logoutTimout = setTimeout(() => {
				this.logout();
			}, this.timeoutDeltaTime);

			// Start counting down time to logout
			this.startCountdown();
		},
		resetTimeouts() {
			clearTimeout(this.popupTimeout);
			clearTimeout(this.logoutTimout);
			this.startTimeouts();
		},
		startCountdown() {
			// Update the remaining time every second
			this.countdownInterval = setInterval(() => {
				const elapsedTime = Date.now() - this.timeoutStartTime; // Time passed
				this.remainingTime = this.timeoutDeltaTime - elapsedTime; // Remaining time

				// If the time is up, clear the interval
				if (this.remainingTime <= 0) {
					clearInterval(this.countdownInterval);
				}
			}, 1000); // Update every second
		},
		addListeners() {
			document.addEventListener('click', this.resetTimeouts);
			document.addEventListener('keydown', this.resetTimeouts);
			document.addEventListener('scroll', this.resetTimeouts);
		},
		removeListeners() {
			document.removeEventListener('click', this.resetTimeouts);
			document.removeEventListener('keydown', this.resetTimeouts);
			document.removeEventListener('scroll', this.resetTimeouts);
		},
		startMonitoring() {
			this.startTimeouts();
			this.addListeners();
		},
		stopMonitoring() {
			this.removeListeners();
			clearTimeout(this.popupTimeout);
			clearTimeout(this.logoutTimout);
		},
        logout() {
			const modal = Modal.getInstance(document.getElementById('attentionCaller'));
			if (modal) {
				modal.hide();
			}

			this.stopMonitoring();

            this.$axios.get('/api/logout')
                .then(() => {
                    localStorage.clear();
                    this.$router.push('/login');
                })
                .catch(() => {
                    // If the server is down, the user is logged out anyway

                    localStorage.clear();
                    this.$router.push('/login');
                });
        },
		handleCustomEvent(event) {
			this.isLoggedIn = event.detail;

			if (this.isLoggedIn) {
				this.startMonitoring();
			} else {
				this.stopMonitoring();
			}
		},
		callAttention() {
			const modal = new Modal(document.getElementById('attentionCaller'));
			modal.show();
		},
		modalButtonClicked() {
			this.resetTimeouts();
			const modal = Modal.getInstance(document.getElementById('attentionCaller'));
			if (modal) {
				modal.hide();
			}
		}
	}
}	
</script>

<style>
/* Import Roboto Font */
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

.app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.page-margin {
	margin-left: 10%;
	margin-right: 10%;
}

.light-div {
	background-color: #ffffff;
	margin-top: 20px;
	margin-bottom: 20px;
}
.dark-div {
	background-color: #42413f;

	border-color: #003867;
	border-style: solid;
	border-top-width: 10px;
	border-bottom-width: 10px;
	border-left-width: 0;
	border-right-width: 0;

	padding-top: 20px;
	padding-bottom: 20px;
}

.font-roboto {
	font-family: 'Roboto', sans-serif;
}

.light-text {
	color: #ffffff;
	font-family: 'Roboto', sans-serif;
}
.dark-text {
	color: #003867;
	font-family: 'Roboto', sans-serif;
}
.yellow-text {
	color: #ffd700;
	font-family: 'Roboto', sans-serif;
}

router-view {
    flex: 1;
}

footer {
    margin-top: auto; /* Garante que o rodapé fique na parte inferior (só funciona aqui >:c) */
}
</style>